<script setup>
import {ref} from "vue";
import AccordionTransition from "@/components/transitions/AccordionTransition.vue";

defineProps({
  label: {
    type: String,
    required: true,
  },
});

const expanded = ref(false);
</script>

<template>
  <div class="tw-my-3">
    <button
      type="button"
      class="tw-flex tw-items-center tw-gap-2 tw-text-everest tw-underline"
      @click="expanded = !expanded"
    >
      {{ label }}
      <span
        :class="{'tw-rotate-180': expanded}"
        class="tw-w-4 tw-transition-transform"
      >
        <SvgVue icon="icons/chevron" />
      </span>
    </button>

    <AccordionTransition>
      <div v-show="expanded">
        <slot />
      </div>
    </AccordionTransition>
  </div>
</template>
